module.exports = __webpack_public_path__ + "img/popop_red_88.8cbd66cc.png";